<template>
	<div>
		<b-container class="container-project">
			<b-row class="mb-5">
				<b-col cols="12" xl="4" class="pr pr-xl-1">
					<multiselect v-if="apartments.length > 1" :allow-empty="false" class="multiselect-sm mb-2 mb-xl-4 multiselect-filter" v-model="selectedApartment" :options="apartments" :close-on-select="true" placeholder="Departamento" track-by="asset_id" :show-labels="false">
						<template slot="noOptions">No hay departamentos disponibles.</template>
						<template slot="singleLabel" slot-scope="props">{{props.option.asset_type.split("_").join(" ")}} {{props.option.number}} <small>{{props.option.project_name}}</small></template>
						<template slot="option" slot-scope="props">{{props.option.asset_type.split("_").join(" ")}} {{props.option.number}} <small>{{props.option.project_name}}</small></template>
					</multiselect>
					<h5 class="pt-2" v-else-if="selectedApartment">{{selectedApartment.asset_type.split("_").join(" ")}} {{selectedApartment.number}} <small>{{selectedApartment.project_name}}</small></h5>
				</b-col>
				<b-col cols="12" xl="8">
					<b-row class="menu-row">
						<b-col cols="6" xl="3" class="px-1">
							<b-button class="filter-btn" :class="selected_tab == 0 ? 'filter-active' : ''" @click="selected_tab = 0" block>Detalle</b-button>
						</b-col>
						<b-col cols="6" xl="3" class="px-1">
							<b-button class="filter-btn" :class="selected_tab == 1 ? 'filter-active' : ''" @click="selected_tab = 1" block>Pagos</b-button>
						</b-col>
						<b-col cols="6" xl="3" class="px-1 mt-2 mt-xl-0">
							<b-button class="filter-btn" :class="selected_tab == 2 ? 'filter-active' : ''" @click="selected_tab = 2" block>Documentos</b-button>
						</b-col>
						<b-col cols="6" xl="3" class="px-1 mt-2 mt-xl-0">
							<b-button class="filter-btn" :class="selected_tab == 3 ? 'filter-active' : ''" @click="selected_tab = 3" block >Tarjetas</b-button>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</b-container>
		<b-tabs content-class="py-3" v-model="selected_tab" squared justified nav-class="d-none">
			<b-tab title="DETALLE" active>
				<div>
					<showApartment :asset_id="asset_id" :key="asset_id" />
				</div>
			</b-tab>
			<b-tab title="PAGOS">
				<div>
					<payments :asset_id="asset_id" :key="asset_id" />
				</div>
			</b-tab>
			<b-tab title="DOCUMENTOS">
				<div>
					<documents :asset_id="asset_id" :key="asset_id" />
				</div>
			</b-tab>
			<b-tab title="TARJETAS">
				<div>
					<users :asset_id="asset_id" :project_id="project_id" :key="asset_id" />
				</div>
			</b-tab>
		</b-tabs>
	</div>
</template>
<script>
import showApartment from "./ShowApartment";
import payments from "./payments/Payments";
import documents from "./documents/Documents";
import users from "./users/Users";

export default {
	name: "options",
	components:{ showApartment, payments, documents, users },
	props: {
		asset_id: {default: null},
		project_id: {default: null},
		tab_index: {default: 0}
	},
	data() {
		return {
			apartments: [],
			selected_tab: this.tab_index,
			selectedApartment: null,
			selected: '',
			options: [
				{value: null, text: 'test'}
			]
		}
	},
	mounted() {
		this.$store.commit("setCards");
		this.setApartments();
	},
	methods: {
		setApartments(){
			this.axios.get("assets/").then(result => {
				if(typeof result.data.length != undefined){
					this.apartments = result.data.assets
					this.$store.commit('setApartments', result.data.assets);
					this.selectedApartment = this.apartments[0];
				}
			}).catch(error => {
				console.log(error)
			});
		},
	},
	computed: {
		project() {
			return (this.selectedApartment ? this.$store.getters.getProjectByMoby(this.selectedApartment.project_id) : null );
		}
	},
	watch:{
		asset_id: {
			handler: function() {
				this.selected_tab = 0;
			}
		},
		selectedApartment(newValue){
			if(newValue){
				this.$emit('selectedApartment', this.selectedApartment);
			}
		}
	}
};
</script>
<style>
.options-nav li a{
	margin: 0px 0px!important;
}
.filter-btn{
	background: transparent !important;
	border-radius:0px!important;
	color:#707070!important;
}
.filter-btn:hover{
	background-color: #c50f2A!important;
	color:white!important;
	border:1px solid #c50f2A!important;
}
.filter-btn-disabled{
	background: transparent !important;
	border-radius:0px!important;
	color:#707070!important
}
.filter-active{
	background-color: #c50f2A!important;
	color:white!important;
	border:1px solid #c50f2A!important;
}
.multiselect-filter{
	color:#707070!important;
	border-radius: 0px!important
}
.multiselect-filter .multiselect__tags{
	border-radius: 0px!important
}
@media (max-width:992px){
	.menu-row{
		padding:0px 11px
	}
}
</style> 